import {
	BaseModal,
	Box,
	Button,
	CSSProperties,
	Image,
	Overlay,
	Typography,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { NavClose } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { ExclamationIcon } from '@themes';

import { useUserIsClientHelper } from './userIsClient.helper';

export const UserIsClientBcpModal: React.FC = () => {
	const { handleOnClickClose, handleYesButton, handleClickGetInTouch, isVisible, currentView, translate } =
		useUserIsClientHelper();

	const generalStyles = {
		modalConfig: {
			background: '#FFFFFF',
			borderRadius: '24px',
		},
		modalContent: {
			flexDirection: 'column',
		},
		bigIconBox: {
			marginBottom: '24px',
			transform: 'rotate(180deg)',
			alignSelf: 'center',
		},
		closeButtonBox: {
			alignSelf: 'end',
		},
		messageBox: {
			textAlign: 'center',
			flexDirection: 'column',
			marginBottom: '16px',
		},
		modalTextContent: {
			flexDirection: 'column',
			alignItems: 'center',
		},
		buttonContainer: {
			justifyContent: 'center',
			gap: '32px',
			width: '100%',
			alignItems: 'center',
		},
	};

	const styles = {
		...generalStyles,
		smallView: {
			...generalStyles,
			modalConfig: {
				...generalStyles.modalConfig,
			},
			messageBox: {
				...generalStyles.messageBox,
				rowGap: '8px',
			},
			modalTextContent: {
				...generalStyles.modalTextContent,
				width: '348px',
				padding: '48px 24px 32px',
			},
			buttonContainer: {
				...generalStyles.buttonContainer,
				width: '100%',
			},
		},
		tabletView: {
			...generalStyles,
			modalConfig: {
				...generalStyles.modalConfig,
			},
			closeButtonBox: {
				...generalStyles.closeButtonBox,
				padding: '24px',
			},
			messageBox: {
				...generalStyles.messageBox,
				rowGap: '16px',
			},
			modalTextContent: {
				...generalStyles.modalTextContent,
				width: '536px',
				padding: '0 24px 72px',
			},
			buttonContainer: {
				...generalStyles.buttonContainer,
			},
		},
		bigView: {
			...generalStyles,
			modalConfig: {
				...generalStyles.modalConfig,
			},
			modalContent: {
				...generalStyles.modalContent,
				padding: '16px 32px 32px',
			},
			closeButtonBox: {
				...generalStyles.closeButtonBox,
				marginBottom: '24px',
			},
			messageBox: {
				...generalStyles.messageBox,
				rowGap: '16px',
			},
			modalTextContent: {
				...generalStyles.modalTextContent,
				width: '700px',
			},
			buttonContainer: {
				...generalStyles.buttonContainer,
			},
		},
	};

	return (
		<BaseModal visible={isVisible} externalBackdrop={<Overlay onPress={handleOnClickClose} />}>
			<Box styles={styles[currentView].modalConfig}>
				<Box styles={styles[currentView].modalContent as CSSProperties}>
					{currentView !== 'smallView' && (
						<Box styles={styles[currentView].closeButtonBox} onPress={handleOnClickClose}>
							<Image
								source={NavClose.Outline}
								svgProps={{
									fill: '#6A717C',
									width: '24px',
									height: '24px',
								}}
							/>
						</Box>
					)}
					<Box styles={styles[currentView].bigIconBox}>
						<ExclamationIcon />
					</Box>
					<Box styles={styles[currentView].modalTextContent as CSSProperties}>
						<Box styles={styles[currentView].messageBox as CSSProperties}>
							<Box styles={{ justifyContent: 'center', flexDirection: 'column', gap: '4px' }}>
								<Typography appearance="body-200-04">
									{translate('simulator.modals.userIsClient.title')}
								</Typography>
								<Typography appearance="body-100-02">
									{translate('simulator.modals.userIsClient.subtitle')}
								</Typography>
							</Box>
						</Box>
						<Box styles={styles[currentView].buttonContainer as CSSProperties}>
							<Button size="large" appearance="ghost" onPress={handleClickGetInTouch}>
								{translate('simulator.modals.userIsClient.requestContact')}
							</Button>
							<Button size="large" onPress={handleYesButton}>
								{translate('simulator.modals.userIsClient.yesClient')}
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
		</BaseModal>
	);
};
